import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdAdd, MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import {
  useGetInvoicesQuery,
  useRemoveInvoiceMutation,
} from "../../features/api/orderinvoiceApi";
import { useRemoveSaleslistMutation } from "../../features/api/saleslistApi";
import { useRemoveTransactionMutation } from "../../features/api/transactionApi";
import {
  useGetQuotationsQuery,
  useRemoveQuotationMutation,
} from "../../features/api/quotationmainApi";
import { useRemoveQuotationItemMutation } from "../../features/api/quotationitemApi";

const Quotation = () => {
  const { data: dlr } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = dlr?.dealer;

  const { data, error, isLoading } = useGetQuotationsQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const quotations = data?.quotation_mains;

  const sortedOrders2 = quotations?.slice().sort((a, b) => b?.id - a?.id);

  const [removeQuotation] = useRemoveQuotationMutation();
  const [removeQuotationItem] = useRemoveQuotationItemMutation();

  const handleDelete = async (id) => {
    console.log(id);
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const response = await removeQuotation(id);
        const result2 = await removeQuotationItem(id);
        if (response) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error?.status);
      }
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    const filteredResults = quotations?.filter((item) =>
      item?.qto_no.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(filteredResults);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-4 ">
        <h1 className="text-xl font-bold">Quotations</h1>
        <Link
          to="/dashboard/quotation/create"
          className="text-white bg-blue-500 cursor-pointer flex items-center p-1"
        >
          {" "}
          <span>
            <MdAdd className="text-2xl" />
          </span>
          <span>New Quotation</span>
        </Link>
      </div>
      <input
        type="text"
        placeholder="Search items"
        className="border focus:outline-none h-10 w-[250px] mb-3 rounded p-1 bg-slate-50"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <div className="h-[73vh] overflow-auto max-w-sm lg:max-w-full py-2 m-auto">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : quotations?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no quotation
          </p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {/* <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell> */}
                  <TableCell
                    style={{ backgroundColor: "#f0f0f5", fontWeight: "bold" }}
                  >
                    Quotation No.
                  </TableCell>
                  <TableCell
                    style={{ backgroundColor: "#f0f0f5", fontWeight: "bold" }}
                  >
                    Quotation Date
                  </TableCell>
                  <TableCell
                    style={{ backgroundColor: "#f0f0f5", fontWeight: "bold" }}
                  >
                    Client
                  </TableCell>
                  <TableCell
                    style={{ backgroundColor: "#f0f0f5", fontWeight: "bold" }}
                  >
                    Amount
                  </TableCell>
                  {/* <TableCell
                    style={{ backgroundColor: "#f0f0f5", fontWeight: "bold" }}
                  >
                    Action
                  </TableCell> */}
                  <TableCell
                    style={{ backgroundColor: "#f0f0f5", fontWeight: "bold" }}
                  >
                    Quotation
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchTerm
                  ? searchResults
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => {
                        const dName = dealers?.find(
                          (dlr) => dlr?.id === row?.client
                        );
                        const passData = { row, dName };
                        return (
                          <TableRow key={row?.id}>
                            {/* <TableCell>{i + 1}</TableCell> */}
                            <TableCell>{row?.qto_no}</TableCell>
                            <TableCell>{formatDate(row?.qto_date)}</TableCell>
                            <TableCell>{dName?.d_name}</TableCell>
                            <TableCell>{row?.grand_total}</TableCell>
                            {/* <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                <span onClick={() => handleDelete(row?.qto_no)}>
                                  <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                                </span>
                              </div>
                            </TableCell> */}
                            <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                <Link
                                  to="/dashboard/quotation/report"
                                  state={passData}
                                >
                                  <span className=" underline text-blue-600">
                                    Quotation
                                  </span>
                                </Link>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })
                  : sortedOrders2
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => {
                        const dName = dealers?.find(
                          (dlr) => dlr?.id === row?.client
                        );
                        const passData = { row, dName };
                        return (
                          <TableRow key={row?.id}>
                            {/* <TableCell>{i + 1}</TableCell> */}
                            <TableCell>{row?.qto_no}</TableCell>
                            <TableCell>{formatDate(row?.qto_date)}</TableCell>
                            <TableCell>{dName?.d_name}</TableCell>
                            <TableCell>{row?.grand_total}</TableCell>
                            {/* <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                <span onClick={() => handleDelete(row?.qto_no)}>
                                  <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                                </span>
                              </div>
                            </TableCell> */}
                            <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                <Link
                                  to="/dashboard/quotation/report"
                                  state={passData}
                                >
                                  <span className=" underline text-blue-600">
                                    Quotation
                                  </span>
                                </Link>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[20, 30, 50]}
              component="div"
              count={quotations?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default Quotation;
